// extracted by mini-css-extract-plugin
export default {"tooltip":"lsf-tooltip","before-appear":"lsf-before-appear","before-disappear":"lsf-before-disappear","appear":"lsf-appear","visible":"lsf-visible","disappear":"lsf-disappear","tooltip_align_top-center":"lsf-tooltip_align_top-center","tooltip_align_bottom-center":"lsf-tooltip_align_bottom-center","tooltip_theme_light":"lsf-tooltip_theme_light","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630374449
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  